// extracted by mini-css-extract-plugin
export default {"footerContainer":"FooterOptions_footerContainer__-4JlY"};